import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Footer from './Footer';
import Header from './Header';
import Breadcrumbs from 'components/Breadcrumbs';
import PageLoader from 'components/PageLoader';
import useConfig from 'hooks/useConfig';
import NavigationScroll from 'components/NavigationScroll';
import SessionWarningModal from 'components/SessionWarningModal';
import SessionExpiredModal from 'components/SessionExpiredModal';
import ChatWidget from 'components/chatbot/ChatWidget';
import ImpersonationBanner from 'components/ImpersonationBanner';
import { SystemConfigService } from 'api/services/systemConfigService';
import { useSystemConfigStore } from 'store/systemConfigStore';
import { useSessionTimer } from 'hooks/useSessionTimer';
import { useForceLogout } from 'hooks/useForceLogout';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const { container } = useConfig();
  const setAppParams  = useSystemConfigStore((s) => s.setAppParams);

  // Cargar parámetros internos al montar (sin restricción de permiso)
  useEffect(() => {
    SystemConfigService.getAppParams().then(setAppParams).catch(() => {});
  }, []);

  const { phase, remainingSeconds, resetTimer } = useSessionTimer();
  useForceLogout();

  return (
    <>
      {/* Va ANTES del encabezado a propósito.

          `.pc-header` es `position: fixed` sin `top`, así que se queda en su
          posición estática: con la franja delante, baja 40px sola. Y
          `.pc-container` es `position: relative; top: 74px`, que ahora cuenta
          desde abajo de la franja. Por eso esto no necesita una sola línea de
          CSS nueva ni tocar el tema; con `position: fixed` en la franja habría
          que recalcular las dos cosas a mano y se desajustaría al primer
          cambio de altura del encabezado. */}
      <ImpersonationBanner />
      <Drawer />
      <Header />
      {/* position:relative para que PageLoader(absolute) se acote a este contenedor */}
      <div className="pc-container" style={{ position: 'relative' }}>
        <PageLoader />
        <div className={`pc-content ${container && 'container'} `}>
          <Breadcrumbs />
          <NavigationScroll>
            <Outlet />
          </NavigationScroll>
        </div>
      </div>
      <Footer />

      <SessionWarningModal
        show={phase === 'warn'}
        remainingSeconds={remainingSeconds}
        onExtend={resetTimer}
      />
      <SessionExpiredModal show={phase === 'expired'} />
      <ChatWidget />
    </>
  );
}
